import classNames from 'classnames';
// import { t } from 'ttag';

import { Skeleton } from '@ui/Skeleton';
import { StarsSkeleton } from '@ui/Stars';

import s from './ProductDetailsSellerInfo.sss';

interface Props {
  className?: string,
}

export const ProductDetailsSellerInfoSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <Skeleton
        width='100px'
        height='14px'
      />

      <div className={s.seller}>
        <Skeleton
          className={s.avatar}
          type='circle'
          width='40px'
          height='40px'
        />

        <p className={s.name}>
          <Skeleton
            width='80%'
            height='14px'
          />
        </p>

        <div className={s.rating}>
          <StarsSkeleton />
        </div>

        <ul className={s.infoList}>
          {Array(4).fill(null).map((_, i) => (
            <li
              key={i}
              className={s.infoItem}
            >
              <Skeleton
                width='100%'
                height='14px'
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
